import styled, { css } from 'styled-components';
import { rem } from 'polished';
var CarouselContainer = styled.div.attrs(function (_ref) {
  var imageWidth = _ref.imageWidth,
      imageHeight = _ref.imageHeight,
      viewportHeight = _ref.viewportHeight;
  return {
    style: {
      height: viewportHeight,
      maxHeight: imageHeight,
      maxWidth: imageWidth
    }
  };
}).withConfig({
  displayName: "CarouselContainer",
  componentId: "sc-1tdtn67-0"
})(["display:block;overflow:hidden;position:relative;width:", ";", " ", " ", ""], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? '100%' : '50%';
}, function (_ref3) {
  var showDivider = _ref3.showDivider,
      backgroundColor = _ref3.backgroundColor;
  return showDivider && css(["&:before,&:after{background-color:", ";content:'';position:absolute;z-index:1;}"], backgroundColor);
}, function (_ref4) {
  var isMobile = _ref4.isMobile,
      showDivider = _ref4.showDivider,
      viewportWidth = _ref4.viewportWidth,
      imageWidth = _ref4.imageWidth,
      alternatePosition = _ref4.alternatePosition;
  return !isMobile && showDivider && css(["&:before,&:after{height:100%;top:0;transform:", ";width:", ";}&:after{box-shadow:-10px 0 10px 0 rgba(0,0,0,0.1);display:", ";right:-", ";}&:before{box-shadow:10px 0 10px rgba(0,0,0,0.1);display:", ";left:-", ";}"], "skew(" + (alternatePosition ? '5deg' : '-5deg') + ")", rem(imageWidth * 0.1), viewportWidth * 0.5 <= imageWidth && alternatePosition ? 'none' : 'block', rem(imageWidth * 0.1 / 2), viewportWidth * 0.5 <= imageWidth && !alternatePosition ? 'none' : 'block', rem(imageWidth * 0.1 / 2));
}, function (_ref5) {
  var isMobile = _ref5.isMobile,
      showDivider = _ref5.showDivider,
      imageHeight = _ref5.imageHeight;
  return isMobile && showDivider && css(["box-shadow:inset 0 10px 10px -10px rgba(0,0,0,0.4);&:before,&:after{width:100%;transform:skew(0deg,2deg);height:", ";}&:after{display:none;}&:before{box-shadow:0 -10px 10px 0 rgba(0,0,0,0.1);display:block;bottom:-", ";}"], rem(imageHeight * 0.05), rem(imageHeight * 0.065 * 0.5));
});
export default CarouselContainer;